export async function getRecaptchaV3Token(action = undefined) {
  return new Promise((resolve) => {
    recaptchaReady().then(async () => {
      const token = await window.grecaptcha.execute(process.env.RECAPTCHA_ID, { action })
      resolve(token)
    })
  })
}

export async function getRecaptchaV2Token(element, options = {}) {
  return new Promise((resolve) => {
    recaptchaReady().then(() => {
      const widgetId = window.grecaptcha.render(element, {
        sitekey: process.env.RECAPTCHA_V2,
        theme: 'dark',
        callback: (token) => {
          window.grecaptcha.reset(widgetId)
          resolve(token)
        },
        ...options,
      })
    })
  })
}

async function recaptchaReady() {
  return new Promise((resolve, reject) => {
    try {
      if (!window._grecaptchaCallbacks) {
        window._grecaptchaCallbacks = []
      }

      if (window._grecaptchaReady || window.grecaptcha) {
        resolve()
        return
      }

      const timeout = setTimeout(() => {
        reject(new Error('ReCAPTCHA не загрузилась'))
      }, 15000)

      window._grecaptchaCallbacks.push(() => {
        clearTimeout(timeout)
        resolve()
      })
    } catch (error) {
      reject(error)
    }
  }).then(() => {
    return new Promise((resolve) => {
      window.grecaptcha.ready(resolve)
    })
  })
}
